import {
  Col,
  Row,
  message,
  Select,
  Button,
  Card,
  Form,
  Input,
  Divider,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { addDewan, fetchOneDewan, updateDewan } from "redux/features/dewan";
import { MyEditor } from "../../../components/Editor";
import ImageUploader from "components/shared-components/ImageUploader";
import { capitalize, filter } from "lodash";
import { fetchAllFraksi } from "redux/features/fraksi";
import { fetchAllKomisi } from "redux/features/komisi";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { useFraksi } from "hooks/useFraksi";
import { useKomisi } from "hooks/useKomisi";
import {
  councilBodyList,
  dapilOptions,
  jabatanOptions,
  layout,
} from "./constant";
import { PhotoUploadCard } from "./PhotoUploadCard";
import { FormList } from "./FormList";

const selectStyle = {
  width: "100%",
  backgroundColor: "white",
};

const rules = [
  {
    required: true,
    message: "Wajib Diisi!",
  },
];

export const ADD_DEWAN = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();
  const location = useLocation();

  const [idBody, setIdBody] = useState("");
  const [enBody, setEnBody] = useState("");
  const [dapil, setDapil] = useState([]);

  const [tags, setTags] = useState();
  const [imgUrl, setImgUrl] = useState("");
  const [imgUrlDisplay, setImgUrlDisplay] = useState("");

  const { fraksi } = useFraksi();
  const { komisi } = useKomisi();

  const onFinish = (values) => {
    if (location?.state?.id) {
      updateData(values);
    } else {
      createData(values);
    }
  };

  const createData = async (values) => {
    console.log("create data :", values);
    try {
      await dispatch(
        addDewan({
          ...values,
          description: idBody ? idBody : "",
          fraksi_id: parseInt(values.fraksi_id),
          komisi_id: parseInt(values.komisi_id),
        })
      ).unwrap();
      history.push("/app/dewan");
    } catch (error) {
      message.error(error?.message || "Failed to fetch data");
    }
  };

  const updateData = async (values) => {
    try {
      await dispatch(
        updateDewan({
          ...values,
          description: idBody ? idBody : "",
          fraksi_id: parseInt(values.fraksi_id),
          komisi_id: parseInt(values.komisi_id),
          fraksi: parseInt(values.fraksi_id),
          komisi: parseInt(values.komisi_id),
          photo: imgUrl ? imgUrl : undefined,
          user_id: 1,
          id: location?.state?.id,
        })
      ).unwrap();
      history.push("/app/dewan");
    } catch (error) {
      message.error(error?.message || "Failed to fetch data");
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const getDataById = async (id) => {
    try {
      const data = await dispatch(fetchOneDewan(id)).unwrap();
      form.setFieldsValue({
        ...data.data,
        fraksi_id: data.data.fraksi?.id,
        jabatan_fraksi: data.data.fraksi?.position,
        komisi_id: data.data.komisi?.id,
        jabatan_komisi: data.data.komisi?.position,
        electoralDistrict: data.data.electoralDistrict?.name,
        councilBody: data.data.councilBody?.map((item) => ({
          //   name: item.name,
          councilBody_id: item.id,
          position: item.position,
          //   councilBody: item.councilBody_id,
        })),
      });
      setImgUrlDisplay(data.data.photo);
    } catch (err) {
      console.log(err);
    }
  };

  const handleImageUpload = (info) => {
    if (info.file.status === "uploading") {
      // setLoading(true);
      return;
    }
    if (info.file.status === "done") {
      setImgUrl(info.file.response.data.secure_url);
    }
  };

  useEffect(() => {
    console.log(location?.state?.id);
    if (location?.state?.id) {
      getDataById(location?.state?.id);
    }
  }, []);

  //     "councilBody": [
  //     {
  //       "councilBody_id": 1,
  //       "position": "Ketua"
  //     }
  //   ],

  return (
    <>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <h2>Tambah/Update Data Anggota Dewan</h2>
          <p>Isi data dewan sesuai dengan data yang ada.</p>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col xs={18} sm={18} md={18} lg={18} gap={3}>
          <Card>
            <Form
              name="basic"
              form={form}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              labelAlign="right"
              autoComplete="off"
              {...layout}
            >
              <Typography.Title level={5}>Informasi Pribadi</Typography.Title>
              <Form.Item label="Nama Lengkap" name="name">
                <Input />
              </Form.Item>

              <Form.Item label="Alamat" name="address">
                <Input />
              </Form.Item>

              <Form.Item label="Jabatan" name="jabatan_komisi">
                <Input />
              </Form.Item>

              <Form.Item label="Email" name="email">
                <Input />
              </Form.Item>

              <Form.Item label="No HP (WA)" name="no_hp">
                <Input />
              </Form.Item>

              <Form.Item label="Pendidikan" name="education">
                <Input />
              </Form.Item>

              <Form.Item label="Periode" name="periode">
                <Input />
              </Form.Item>

              <Divider></Divider>
              <Typography.Title level={5}>Fraksi</Typography.Title>

              <Form.Item label="Fraksi" name="fraksi_id">
                <Select placeholder="Pilih Fraksi">
                  {fraksi.map((item) => (
                    <Select.Option key={item.value} value={item.value}>
                      {item.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item label="Jabatan Fraksi" name="jabatan_fraksi">
                <Select placeholder="Pilih Jabatan Fraksi">
                  {jabatanOptions.map((item) => (
                    <Select.Option value={item.value}>
                      {item.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Divider></Divider>
              <Typography.Title level={5}>Komisi</Typography.Title>

              <Form.Item label="Komisi" name="komisi_id">
                <Select placeholder="Pilih Komisi">
                  {komisi.map((item) => (
                    <Select.Option key={item.value} value={item.value}>
                      {item.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item label="Jabatan Komisi" name="jabatan_komisi">
                <Select placeholder="Pilih Jabatan Komisi">
                  {jabatanOptions.map((item) => (
                    <Select.Option value={item.value}>
                      {item.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Divider></Divider>
              <Typography.Title level={5}>Dapil</Typography.Title>

              <Form.Item label="Dapil" name="electoralDistrict_id">
                <Select placeholder="Pilih Dapil">
                  {dapilOptions.map((item) => (
                    <Select.Option key={item.value} value={item.value}>
                      {item.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Divider></Divider>
              <Typography.Title level={5}>
                Alat Kelengkapan Dewan
              </Typography.Title>

              <Form.Item label="AKD">
                <FormList
                  councilBodyList={councilBodyList}
                  jabatanOptions={jabatanOptions}
                ></FormList>
              </Form.Item>

              {/* <Form.Item>
                <MyEditor
                  data={idBody}
                  setState={setIdBody}
                  defaultValue="Indonesian Content"
                />
              </Form.Item> */}

              <Form.Item wrapperCol={24}>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ width: "100%" }}
                >
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
        <Col xs={6} sm={6} md={6} lg={6} gap={3}>
          <PhotoUploadCard
            imgUrlDisplay={imgUrlDisplay}
            imgUrl={imgUrl}
            onChangeImage={handleImageUpload}
          ></PhotoUploadCard>
        </Col>
      </Row>
    </>
  );
};

export default ADD_DEWAN;
